import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-card-other',
  templateUrl: './card-other.component.html',
  styleUrls: ['../card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CardOtherComponent implements OnInit {
  @Input() translation: string;
  @Input() img: string;
  @Input() link: string;

  constructor() {}

  ngOnInit(): void {}
}
